<template>
    <div class="card-body p-0">
        <div class="yearly-view" id="yearly-view" style="min-height: 218px;">
            <apexchart height="203"  type="area" :options="apexDashboard.options"
                :series="apexDashboard.series"></apexchart>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
var primary = localStorage.getItem('primary_color') || '#534686'
export default {
    data: function () {
        return {
            apexDashboard: {
                options: {
                    chart: {
    height: 203,
    type: "area",
    toolbar: {
      show: false,
    },
  },
  stroke: {
    curve: "smooth",
    width: [5, 1],
    dashArray: [0, 5],
  },
  fill: {
    type: "gradient",
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.5,
      opacityTo: 0.9,
      stops: [0, 100],
    },
  },

  markers: {
    size: 0,
    colors: undefined,
    strokeColors: [primary],
    strokeWidth: [8, 0],
    strokeOpacity: 0.3,
    strokeDashArray: 0,
    fillOpacity: 1,
    discrete: [],
    shape: "circle",
    radius: 2,
    offsetX: 0,
    offsetY: 0,
    onClick: undefined,
    onDblClick: undefined,
    showNullDataPoints: true,
    hover: {
      size: 7,
      sizeOffset: 3,
    },
  },
  responsive: [
    {
      breakpoint: 1401,
      options: {
        chart: {
          height: 210,
        },
      },
    },
    {
      breakpoint: 992,
      options: {
        chart: {
          height: 200,
        },
      },
    },
  ],
  yaxis: {
    show: false,
  },
  grid: {
    show: false,
  },
  xaxis: {
    show: false,
    labels: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      show: true,
      width: 1,
      position: "back",
      stroke: {
        color: primary,
        width: 1,
        dashArray: 5,
      },
    },
  },
  tooltip: {
    marker: {
      show: false,
    },
    fixed: {
      enabled: false,
      position: "bottomRight",
      offsetX: 0,
      offsetY: 0,
    },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: false,
  },
  colors: [primary],
                },
                series: [ {
      type: "area",
      data: [20, 20, 50, 90, 70, 80, 30, 45, 35, 95, 70, 45, 90],
    },
                ],
            },
        }
    },
    computed: {
        ...mapState({ primaryColor: (state) => state.layout.primaryColor })
    }
};
</script>